/**
 * @description 문자열을 최대 길이로 절단하는 함수
 *
 * 네이티브 maxlength 속성은 한글 IME 조합 입력이 경계에서 상한을 넘을 수 있어, onChange에서 이 함수로 상한을 강제한다.
 * String.length(UTF-16 code unit)와 같은 셈법이라 maxlength 속성·글자수 카운터 표기와 항상 일치한다.
 * @returns 최대 길이 이하로 절단된 문자열
 */
const limitLength = (value: string, maxLength: number) => {
  if (value.length <= maxLength) return value;

  const sliced = value.slice(0, maxLength);
  const lastCharCode = sliced.charCodeAt(sliced.length - 1);

  // 절단 경계에서 서로게이트 페어가 잘리면 반쪽(고위 서로게이트)을 버려 깨진 문자를 남기지 않는다
  return lastCharCode >= 0xd800 && lastCharCode <= 0xdbff ? sliced.slice(0, -1) : sliced;
};

export default limitLength;
